import { useCallback, useMemo } from 'react'
import SelectBox from 'components/form/SelectBox'
import { showKeywordBiddingStrategyEdit } from 'features/dashboard/operation/keywordBiddingStrategyEdit/keywordBiddingStrategyEditModalSlice'
import { batch, shallowEqual, useDispatch, useSelector } from 'react-redux'
import { setStrategies } from 'features/dashboard/operation/keywordBiddingStrategyEdit/keywordsBiddingStrategyEditSlice'
import { BiddingStrategyTypes, CampaignTypes } from 'features/Codes'
import {
  KeywordTableEditTypes,
  setEditType,
  setSelectedIds,
} from 'features/dashboard/table/keyword/keywordTableSlice'
import { useAlert } from '../../../dialog/Alert'

const KeywordBiddingStrategyEditSelect = () => {
  const dispatch = useDispatch()
  const { content, selectedIds } = useSelector(
    ({ dashboard }) => dashboard.table.keywordTable,
    shallowEqual
  )
  const disabled = useMemo(
    () =>
      selectedIds.length === 0 ||
      content
        .filter(({ id }) => selectedIds.includes(id))
        .every(({ keywordType }) => keywordType === CampaignTypes.TALK_CHANNEL),
    [selectedIds, content]
  )
  const selectedPremiumLinkKeywords = useMemo(
    () =>
      content.filter(
        ({ id, keywordType }) =>
          selectedIds.includes(id) && keywordType === CampaignTypes.PREMIUM_LINK
      ),
    [content, selectedIds]
  )
  const biddingStrategies = useMemo(
    () =>
      selectedPremiumLinkKeywords.map(
        ({
          id,
          text,
          biddingStrategy,
          parentDomainInfo: {
            adGroup: { maxBiddingAmount: adGroupMaxBiddingAmount },
          },
        }) => ({
          id,
          text,
          biddingStrategy,
          adGroupMaxBiddingAmount,
        })
      ),
    [selectedPremiumLinkKeywords]
  )
  const [TalkChannelAlert, showTalkChannelAlert] = useAlert()

  const handleModalEditClick = useCallback(() => {
    dispatch(showKeywordBiddingStrategyEdit(biddingStrategies))
  }, [dispatch, biddingStrategies])
  const setMaxBiddingAmountEditType = useCallback(() => {
    batch(() => {
      dispatch(
        setStrategies(
          selectedPremiumLinkKeywords.map(
            ({ id, biddingStrategy: { maxBiddingAmount } }) => ({
              keywordId: id,
              biddingStrategyType:
                BiddingStrategyTypes.FIXBIDDING_BY_CUSTOM_MAX_BIDDING,
              maxBiddingAmount,
            })
          )
        )
      )
      dispatch(setEditType(KeywordTableEditTypes.maxBiddingAmount))
    })
  }, [dispatch, selectedPremiumLinkKeywords])
  const handleTableEditClick = useCallback(() => {
    if (selectedIds.length > selectedPremiumLinkKeywords.length) {
      showTalkChannelAlert()
    } else {
      setMaxBiddingAmountEditType()
    }
  }, [
    selectedIds,
    selectedPremiumLinkKeywords,
    showTalkChannelAlert,
    setMaxBiddingAmountEditType,
  ])
  const handleAlertEditConfirm = useCallback(
    ({ isConfirmed }) => {
      if (isConfirmed) {
        dispatch(
          setSelectedIds(selectedPremiumLinkKeywords.map(({ id }) => id))
        )
        setMaxBiddingAmountEditType()
      }
    },
    [dispatch, selectedPremiumLinkKeywords, setMaxBiddingAmountEditType]
  )

  return (
    <>
      <SelectBox
        noBlurOnDefault
        placeholder="입찰가 변경"
        value
        disabled={disabled}>
        <SelectBox.Item
          tiaraAction="키워드탭_입찰가_일괄_클릭"
          onClick={handleModalEditClick}>
          일괄변경
        </SelectBox.Item>
        <SelectBox.Item
          tiaraAction="키워드탭_입찰가_개별_클릭"
          onClick={handleTableEditClick}>
          개별변경
        </SelectBox.Item>
      </SelectBox>
      <TalkChannelAlert title="입찰가 변경" onClose={handleAlertEditConfirm}>
        톡채널검색 유형의 키워드는 입찰가 변경이 불가능하여 선택에서
        제외되었습니다.
      </TalkChannelAlert>
    </>
  )
}
export default KeywordBiddingStrategyEditSelect
